import { useSelector } from 'react-redux';
import { standAlone } from '../../../global/ducks/epi-api';
import { useBasePath } from '../../../global/hooks/useBasePath';
import { YesNoIndicators } from '../../../global/models/api-model';
import { TcsmStates } from '../../../root/tcsm-model';
import { AccountInfoRoutes } from '../../account-info/constants/routes';
import { ArcRoutes } from '../../arc/constants/routes';
import { MyCpgPods, MyCpgPodsSettings, MyCpgPodsTypes } from '../mycpg-pod-models';

export interface PodNavOption {
	type: MyCpgPodsTypes;
	text: string;
	value: string;
}

export function usePodNavOptions() {
	const podData = useSelector<TcsmStates, MyCpgPods>(state => state?.mycpgPodsState?.pods);
	const podSettings = useSelector<TcsmStates, MyCpgPodsSettings>(state => state?.epiProps?.podsSettingsState?.epiContent);
	const navOptions: PodNavOption[] = [];
	const basePath = useBasePath(standAlone ? ArcRoutes.BenAdminPodsNoSlash : AccountInfoRoutes.MyCpgRoot);

	if (podData?.db_data?.show_pod === YesNoIndicators.Yes) {
		navOptions.push({ type: MyCpgPodsTypes.PENSION, value: `${basePath}?type=${MyCpgPodsTypes.PENSION}`, text: podSettings?.pensionPlanDetailTitle });
	}
	if (podData?.dc_data?.show_pod === YesNoIndicators.Yes) {
		navOptions.push({ type: MyCpgPodsTypes.DC, value: `${basePath}?type=${MyCpgPodsTypes.DC}`, text: podSettings?.pensionPlanDcDetailTitle });
	}
	if (podData?.rsvp_data?.show_pod === YesNoIndicators.Yes) {
		navOptions.push({ type: MyCpgPodsTypes.RSVP, value: `${basePath}?type=${MyCpgPodsTypes.RSVP}`, text: podSettings?.rsvpPlanDetailTitle });
	}
	if (podData?.medical_data?.show_pod === YesNoIndicators.Yes || podData?.dental_data?.show_pod === YesNoIndicators.Yes) {
		navOptions.push({ type: MyCpgPodsTypes.HEALTH, value: `${basePath}?type=${MyCpgPodsTypes.HEALTH}`, text: podSettings?.healthPlanDetailTitle });
	}
	if (podData?.life_data?.show_pod === YesNoIndicators.Yes) {
		navOptions.push({ type: MyCpgPodsTypes.LIFE, value: `${basePath}?type=${MyCpgPodsTypes.LIFE}`, text: podSettings?.lifePlanDetailTitle });
	}
	if (podData?.annuity_data?.show_pod === YesNoIndicators.Yes) {
		navOptions.push({ type: MyCpgPodsTypes.ANNUITY, value: `${basePath}?type=${MyCpgPodsTypes.ANNUITY}`, text: podSettings?.annuityPlanTitle });
	}
	if (podData?.disability_data?.disability_pod === YesNoIndicators.Yes) {
		navOptions.push({ type: MyCpgPodsTypes.DISABLE, value: `${basePath}?type=${MyCpgPodsTypes.DISABLE}`, text: podSettings?.disabilityDetailTitle });
	}
	if (podData?.employment_data?.show_pod === YesNoIndicators.Yes) {
		navOptions.push({ type: MyCpgPodsTypes.EMPLOYMENT, value: `${basePath}?type=${MyCpgPodsTypes.EMPLOYMENT}`, text: podSettings?.employmentHistoryTitle });
	}
	return navOptions;


}